<template>
  <div class="row" id="reports">
    <div class="col-12">
      <v-col
        v-if="dowloading"
        class="subtitle-1 text-center"
        cols="12"
      > Cargando por favor espere...
      </v-col>
      <v-progress-linear
        indeterminate
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        height="10"
        v-if="dowloading"
      ></v-progress-linear>
      <v-form @submit.prevent="reset" @keydown="form.onKeydown($event)" ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @downloadExcel="downloadExcel"
          />
          <v-layout :id="ref" class="wrap justify-space-around form-body">
            <v-col lg="6" md="6" sm="6" cols="6">
              <vuetify-select :states="cat_province_id" />
            </v-col>
            <v-col lg="6" md="6" sm="6" cols="12">
              <v-select
                v-model="form.status"
                :items="itemsStatus"
                label="Estatus de Pago"
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col lg="6" md="6" sm="6" cols="12">
              <v-menu
                  v-model="form.dateMenu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedStart"
                      label="Fecha de Transacción Inicio"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      :max="form.dateMax"
                      v-model="form.dateStart"
                      @input="form.dateMenu1 = false"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('one')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
            <v-col lg="6" md="6" sm="6" cols="12">
              <v-menu
                  v-model="form.dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedEnd"
                      label="Fecha de Transacción Fin"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      v-model="form.dateEnd"
                      :max="form.dateMax"
                      @input="form.dateMenu2 = false"
                    />
                  </v-col>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('two')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <v-col>
      <strong>Total de Registros Encontrados: {{ this.totalDocument }}</strong>
      <br/><br/>
      <strong>Total de Archivos a Descargar: {{ this.laps }}</strong>
      <br/><br/>
      <v-progress-linear
        v-model="progress"
        height="25"
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        dark
        v-if="dowloading"
      >
        <strong>{{ Math.ceil(progress) }}%</strong>
      </v-progress-linear>
    </v-col>
  </div>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import { mask } from 'vue-the-mask';
import Toolbar from '~/components/Toolbar';
import VuetifySelect from '~/components/VuetifySelect';
import 'vuetify/src/styles/main.sass';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportPayment') };
  },
  components: {
    Toolbar,
    VuetifySelect,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
    }),
    ref() {
      return this.form.id;
    },
    computedDateFormattedStart() {
        return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
        return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
    },
  },
   directives: {
      mask,
    },
  data: () => ({
    title: 'Reporte de Pagos',
    form: new Form({
      busy: false,
      dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMax: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMenu1: false,
      dateMenu2: false,
      status: 'ACCP',
      typePortal: 'C',
      offset: 0,
      limit: 10000,
      enterpriseRif: '',
    }),
    label: 'Por Defecto',
    progress: 0,
    totalDocument: 0,
    laps: 0,
    valid: false,
    itemsStatus: [
      { value: 'ACCP', text: 'Operación aceptada' },
      { value: 'RJCT', text: 'Operación rechazada' },
      { value: 'WAIT', text: 'Operación en espera de validación de código' },
      { value: 'AG09', text: 'Pago no recibido' },
      { value: 'AC00', text: 'Operación en espera de respuesta del receptor' },
      { value: 'AB01', text: 'Tiempo de espera agotado' },
      { value: 'AB07', text: 'Agente fuera de línea' },
      { value: 'AC01', text: 'Número de cuenta incorrecto' },
      { value: 'AC04', text: 'Cuenta cancelada' },
      { value: 'AC06', text: 'Cuenta bloqueada' },
      { value: 'AC09', text: 'Moneda no válida' },
      { value: 'AG10', text: 'Agente suspendido o excluido' },
      { value: 'AM02', text: 'Monto de la transacción no permitido' },
      { value: 'AM03', text: 'Moneda no permitida' },
      { value: 'AM04', text: 'Saldo insuficiente' },
      { value: 'AM05', text: 'Operación duplicada' },
      { value: 'BE01', text: 'Datos del cliente no corresponden a la cuenta' },
      { value: 'BE20', text: 'Longitud del nombre inválida' },
      { value: 'CH20', text: 'Número de decimales incorrecto' },
      { value: 'DU01', text: 'Identificación de mensaje duplicado' },
      { value: 'ED05', text: 'Liquidación fallida' },
      { value: 'FF05', text: 'Código del producto incorrecto' },
      { value: 'FF07', text: 'Código del subproducto incorrecto' },
      { value: 'RC08', text: 'Código del banco no existe en el sistema de compensación / liquidación' },
      { value: 'TKCM', text: 'Código único de operación de débito incorrecto' },
      { value: 'TM01', text: 'Fuera del horario permitido' },
      { value: 'VE01', text: 'Rechazo técnico' },
      { value: 'DT03', text: 'Fecha de procesamiento no bancaria no válida' },
      { value: 'TECH', text: 'Error técnico al procesar liquidación' },
      { value: 'PRCS', text: 'Liquidación Lipone procesada' },
      { value: 'REJT', text: 'Solicitud de liquidación Lipone rechazada' },
      { value: 'AG01', text: 'Transacción restringida' },
      { value: 'MD09', text: 'Afiliación inactiva' },
      { value: 'MD15', text: 'Monto incorrecto' },
      { value: 'MD21', text: 'Cobro no permitido' },
      { value: 'CUST', text: 'Cancelación solicitada por el deudor' },
      { value: 'DS02', text: 'Operación cancelada' },
      { value: 'MD01', text: 'No posee afiliación' },
      { value: 'MD22', text: 'Afiliación suspendida' },
    ],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => (!v || v.length <= 12) || 'El campo debe tener máximo 12 caracteres.',
      rucFormat: (v) => (!v || /^[V,J,E,P,G]{1}[-][0-9]{1,9}[-][0-9]{1} || [V,J,E,P,G]{1}[-][0-9]{1,9}$/.test(v)) || 'Formato inválido.',
    },
    allHeaders: [{
      text: 'Nº Identificación Emisor',
      value: 'emisor_number_id',
      align: 'left',
      sortable: true,
    }, {
      text: 'Nº Identificación Adquiriente',
      value: 'receiver_number_id',
      align: 'left',
      sortable: true,
    }, {
      text: 'Serie',
      value: 'serie',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Nº Documento',
      value: 'document_number',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Nº Control',
      value: 'control_number',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Emisión',
      value: 'issue_date',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Recepción',
      value: 'reception_date',
      align: 'left',
      sortable: true,
    }, {
      text: 'Estado',
      value: 'status',
      align: 'left',
      sortable: true,
      }, {
      text: 'Observaciones',
      value: 'comments',
      align: 'left',
      sortable: true,
    }],
    documents: 0,
    dowloading: false,
    show: false,
    buttons: [
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      },
    ],
    showFilters: false,
    cat_province_id: '',
  }),
  mounted() {
     this.form.dateStart = moment(this.form.dateStart).subtract(7, 'days').format('YYYY-MM-DD');
  },
  methods: {
    async downloadExcel() {
      const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
      if (dateRange > 1) {
            this.$store.dispatch('notifications/show', {
                  message: 'El rango de consulta no debe ser mayor a un mes',
                  type: 'error',
              });
               this.documents = '';
      } else if (this.$store.state.taxpayer.rif === null) {
            this.$store.dispatch('notifications/show', {
                  message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
                  type: 'error',
              });
               this.documents = '';
      } else {
        this.form.rucSupplier = this.$store.state.taxpayer.rif;
        this.dowloading = true;
        this.form.busy = true;
        this.form.enterpriseRif = this.$store.state.taxpayer.rif;
        this.form.offset = 0;

        const countDocument = await window.axios({
            method: 'post',
            url: '/api/reportPayments/count',
            data: this.form,
          });
          this.totalDocument = countDocument.data;
          this.laps = 0;
          const laps = this.totalDocument % this.form.limit > 0
                      ? parseInt(this.totalDocument / this.form.limit, 10) + 1
                      : this.totalDocument / this.form.limit;
            for (let i = 0; i < laps; i++) {
              this.laps = laps;
              // eslint-disable-next-line
              const { data } = await this.getReport();
              this.form.offset = (i + 1) * this.form.limit;
              this.downloadFile(data, `Reporte de pagos ${i + 1} de ${laps} Fecha ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`);
              const value = (this.totalDocument / laps) * (i + 1);
              this.progress = (value / this.totalDocument) * 100;
            }

            setTimeout(() => {
              this.dowloading = false;
              this.form.busy = false;
              this.progress = 0;
            }, 1000);
      }
    },
    getReport() {
      const url = '/api/reportPayments';
      this.form.enterpriseRif = this.$store.state.taxpayer.rif;
      return window.axios({
        method: 'post',
        url,
        responseType: 'arraybuffer',
        data: this.form,
      }).catch((e) => {
        // eslint-disable-next-line
        console.log(e);
      });
    },
    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },
    getColor(status) {
        if (status.indexOf('1') !== -1) return 'green';
        return 'red';
    },
    today(menu) {
      if (menu === 'one') {
        this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu1 = false;
      } else {
        this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu2 = false;
      }
    },
  },
};
</script>
